import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiUsers,
  FiAlertCircle,
  FiXCircle,
  FiCheckCircle,
  FiTrendingUp,
  FiFileText,
  FiClock,
  FiDollarSign,
  FiDownload,
  FiRefreshCw,
} from "react-icons/fi";
import BseLoginCard from "../common/BseLoginCard";

export default function AdminDashboard() {
  // Static data - replace with API calls later
  const [dashboardData] = useState({
    kycPending: 24,
    failedOrders: 18,
    sipBounces: 12,
    planSales: 45,
    ticketsSLA: 8,
    totalUsers: 1250,
    activeAgents: 35,
    monthlyRevenue: 1250000,
  });

  const [queues] = useState([
    { id: 1, name: "KYC Review Queue", count: dashboardData.kycPending, route: "/admin/users/kyc-review", color: "#f59e0b", icon: FiAlertCircle },
    { id: 2, name: "Failed Orders", count: dashboardData.failedOrders, route: "/admin/mutual-funds/orders-monitor", color: "#ef4444", icon: FiXCircle },
    { id: 3, name: "SIP Bounces", count: dashboardData.sipBounces, route: "/admin/mutual-funds/sip-monitor", color: "#f59e0b", icon: FiRefreshCw },
    { id: 4, name: "Tickets SLA", count: dashboardData.ticketsSLA, route: "/admin/support/ticket-console", color: "#ef4444", icon: FiClock },
  ]);

  const [recentActivities] = useState([
    { id: 1, type: "KYC", action: "New KYC submission", user: "Rajesh Kumar", time: "5 minutes ago", status: "pending" },
    { id: 2, type: "Order", action: "Order failed", orderId: "ORD-001", time: "15 minutes ago", status: "failed" },
    { id: 3, type: "SIP", action: "SIP bounce detected", user: "Priya Sharma", time: "1 hour ago", status: "warning" },
    { id: 4, type: "Ticket", action: "New support ticket", ticketId: "TKT-123", time: "2 hours ago", status: "open" },
  ]);

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "#f59e0b";
      case "failed":
        return "#ef4444";
      case "warning":
        return "#f59e0b";
      case "open":
        return "#3b82f6";
      default:
        return "#64748b";
    }
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink>
                  </li>
                </ol>
              </nav>
              <div className="content-page-header content-page-headersplit d-flex justify-content-between align-items-center flex-wrap gap-4">
                <h5>Admin Dashboard</h5>
                <BseLoginCard />
              </div>
            </div>

            {/* Key Metrics Cards Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row g-3">
              {/* KYC Pending */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>KYC Pending</p>
                        <h3 className="mb-0" style={{ color: "#f59e0b", fontSize: "28px", fontWeight: "600" }}>
                          {dashboardData.kycPending}
                        </h3>
                      </div>
                      <div style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "8px",
                        background: "#fef3c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <FiAlertCircle style={{ fontSize: "24px", color: "#f59e0b" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Failed Orders */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Failed Orders</p>
                        <h3 className="mb-0" style={{ color: "#ef4444", fontSize: "28px", fontWeight: "600" }}>
                          {dashboardData.failedOrders}
                        </h3>
                      </div>
                      <div style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "8px",
                        background: "#fee2e2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <FiXCircle style={{ fontSize: "24px", color: "#ef4444" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* SIP Bounces */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>SIP Bounces</p>
                        <h3 className="mb-0" style={{ color: "#f59e0b", fontSize: "28px", fontWeight: "600" }}>
                          {dashboardData.sipBounces}
                        </h3>
                      </div>
                      <div style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "8px",
                        background: "#fef3c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <FiRefreshCw style={{ fontSize: "24px", color: "#f59e0b" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Plan Sales */}
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Plan Sales</p>
                        <h3 className="mb-0" style={{ color: "#10b981", fontSize: "28px", fontWeight: "600" }}>
                          {dashboardData.planSales}
                        </h3>
                      </div>
                      <div style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "8px",
                        background: "#d1fae5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <FiTrendingUp style={{ fontSize: "24px", color: "#10b981" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>

            {/* Queues Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row g-3">
              {queues.map((queue) => {
                const IconComponent = queue.icon;
                return (
                  <div key={queue.id} className="col-12 col-sm-6 col-md-6 col-lg-3">
                    <NavLink
                      to={queue.route}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div className="card" style={{ cursor: "pointer", transition: "all 0.3s ease" }}>
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "8px",
                              background: `${queue.color}20`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}>
                              <IconComponent style={{ fontSize: "24px", color: queue.color }} />
                            </div>
                            <span className="badge" style={{
                              background: `${queue.color}20`,
                              color: queue.color,
                              padding: "6px 12px",
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}>
                              {queue.count}
                            </span>
                          </div>
                          <h6 className="mb-0" style={{ color: "#1e293b", fontWeight: "600", fontSize: "14px" }}>
                            {queue.name}
                          </h6>
                        </div>
                      </div>
                    </NavLink>
                  </div>
                );
              })}
              </div>
            </div>

            {/* Additional Metrics Row with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row g-3">
              {/* Total Users */}
              <div className="col-12 col-md-4">
                <div className="card">
                  <div className="card-body">
                    <h6 className="mb-3" style={{ color: "#1e293b", fontWeight: "600" }}>
                      Total Users
                    </h6>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h3 className="mb-0" style={{ color: "#1e293b", fontSize: "32px", fontWeight: "600" }}>
                          {dashboardData.totalUsers.toLocaleString()}
                        </h3>
                        <p className="mb-0 mt-2" style={{ color: "#64748b", fontSize: "14px" }}>
                          Registered users
                        </p>
                      </div>
                      <div style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "8px",
                        background: "#f0f9ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <FiUsers style={{ fontSize: "28px", color: "#006e82" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Active Agents */}
              <div className="col-12 col-md-4">
                <div className="card">
                  <div className="card-body">
                    <h6 className="mb-3" style={{ color: "#1e293b", fontWeight: "600" }}>
                      Active Agents
                    </h6>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h3 className="mb-0" style={{ color: "#1e293b", fontSize: "32px", fontWeight: "600" }}>
                          {dashboardData.activeAgents}
                        </h3>
                        <p className="mb-0 mt-2" style={{ color: "#64748b", fontSize: "14px" }}>
                          Active this month
                        </p>
                      </div>
                      <div style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "8px",
                        background: "#f0f9ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <FiUsers style={{ fontSize: "28px", color: "#006e82" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Monthly Revenue */}
              <div className="col-12 col-md-4">
                <div className="card">
                  <div className="card-body">
                    <h6 className="mb-3" style={{ color: "#1e293b", fontWeight: "600" }}>
                      Monthly Revenue
                    </h6>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h3 className="mb-0" style={{ color: "#1e293b", fontSize: "32px", fontWeight: "600" }}>
                          {formatINR(dashboardData.monthlyRevenue)}
                        </h3>
                        <p className="mb-0 mt-2" style={{ color: "#64748b", fontSize: "14px" }}>
                          This month
                        </p>
                      </div>
                      <div style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "8px",
                        background: "#f0f9ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <FiDollarSign style={{ fontSize: "28px", color: "#006e82" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>

            {/* Recent Activities Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mb-0" style={{ color: "#1e293b", fontWeight: "600" }}>
                        Recent Activities
                      </h6>
                      <button
                        className="btn btn-primary btn-sm"
                        style={{ fontSize: "14px" }}
                      >
                        <FiDownload style={{ fontSize: "16px", marginRight: "6px" }} />
                        Export Report
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table datatable">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Action</th>
                            <th>Details</th>
                            <th>Time</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {recentActivities.map((activity) => (
                            <tr key={activity.id}>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {activity.type}
                                </span>
                              </td>
                              <td style={{ color: "#1e293b", fontWeight: "500" }}>
                                {activity.action}
                              </td>
                              <td style={{ color: "#64748b" }}>
                                {activity.user || activity.orderId || activity.ticketId || "N/A"}
                              </td>
                              <td style={{ color: "#64748b", fontSize: "14px" }}>
                                {activity.time}
                              </td>
                              <td>
                                <span className="badge" style={{
                                  background: `${getStatusColor(activity.status)}20`,
                                  color: getStatusColor(activity.status),
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {activity.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
